import { NeoModel, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class UnlockUserCommand extends ValueObject {

    public userId: string = "";

    public emailAddress: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Unlock User Command";
    }
}